import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";

import { PaymentUploadedParser } from "../../../../components/DirectDeposit/Transactions/PaymentUploadedParser";


export interface IPaymentUploadedParserPage  { }

export const PaymentUploadedParserPage : FC<IPaymentUploadedParserPage > = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Validation Parser"
			breadcrumbCurrentPageName=""
			// breadcrumbLinks={[]}
			mainContents={<PaymentUploadedParser />}
		/>
	);
};
